/**
 * Returns true if the error is a server error (5xx status code).
 *
 * Works with any error shape that has a `response.status` property (e.g. AxiosError),
 * without importing Axios directly — keeps presentation layer decoupled from HTTP clients.
 *
 * @param error - Any value caught in a try/catch
 * @returns True if the error has a 5xx status code
 */
export const isServerError = (error: unknown): boolean => {
  if (typeof error !== 'object' || error === null) return false;
  const status = (error as { response?: { status?: number } }).response?.status;
  return typeof status === 'number' && status >= 500;
};
